// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__kcI59","wrapper":"Faq_wrapper__RGxIq","inner":"Faq_inner__Yw3rR","help__block":"Faq_help__block__vpwyg","help__block-text":"Faq_help__block-text__Kw-J3"};